import { getList as _getList, getAll as _getAll } from "../../api";

const BASE_URL = "/settings/permissions";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "groupOfPermissions",
    orderDirection: "asc",
    pageNumber: 0,
    pageSize: 10,
};

export function getAll({ onSuccess, onError }) {
    _getAll({ url: BASE_URL, onSuccess, onError });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError });
}
